export default "__VITE_ASSET__Dj056ISU__"